import qs from './query-string-util';
import * as deviceUtils from 'detect-mobile-device';

/**
 * 通过 user agent 获取对应 utm_source
 */
export function getUtmSourceByUA() {
  if (deviceUtils.isJianghuDaily()) {
    return 'daily';
  } else if (deviceUtils.isWeiXin()) {
    return 'wx';
  } else if (deviceUtils.isMWeibo()) {
    return 'wb';
  } else if (deviceUtils.isMQQ()) {
    return 'qq';
  }
  return undefined;
}

/**
 * utm_source 缓存
 */
let utmSourceCache;

/**
 * 获取地址栏中的 utm_source
 * 如: https://material-ui.com/zh/discover-more/backers?utm_source=wx
 * getUtmSource()
 * // wx
 *
 * @param {boolean} shouldAlsoGetFromUA - 是否也应该通过 UA 中自动检测 utm_source, 这里的优先级会是 "默认从 url 中获取 utm_source" > "UA 获取 utm_source"
 */
export default function getUtmSource(shouldAlsoGetFromUA = true) {
  if (utmSourceCache === undefined) {
    const utmSource = qs.getSearchParams().utm_source;
    if (utmSource) {
      utmSourceCache = utmSource;
    } else {
      utmSourceCache = shouldAlsoGetFromUA ? getUtmSourceByUA() : '';
    }
  }
  return utmSourceCache;
}
